import { FunctionComponent, useState, useEffect } from "react";
import { RTABAK_URLS } from "../../../../utils/urls";
import GetAllHighlightedSearches from "../GetAllHighlightedSearches";
import request from "../../../../services/request";

const AdminHighlightedSearchesContainer: FunctionComponent = ({ }) => {
  const [getHighlightedSearches, setGetHighlightedSearches] =
    useState<Search[]>();
  const [newHighlightedSearche, setNewHighlightedSearch] =
    useState<boolean>(false);

  useEffect(() => {
    getData();
  }, []);
  useEffect(() => {
    if (newHighlightedSearche) {
      getData();
      setNewHighlightedSearch(false);
    }
  }, [newHighlightedSearche]);

  const getData = () => {
    request({
      baseURL: RTABAK_URLS.API.GetHighlightedSearches,
      method: "GET",
    }).then((data) => setGetHighlightedSearches(data));
  };

  return (
    <section>
      {getHighlightedSearches && (
        <GetAllHighlightedSearches
          searches={getHighlightedSearches}
          setNewHighlightedSearch={setNewHighlightedSearch}
        />
      )}
    </section>
  );
};

export default AdminHighlightedSearchesContainer;
